var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimerTwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_20475)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H8C3.58172 0 0 3.58172 0 8V48C0 52.4183 3.58172 56 8 56H48C52.4183 56 56 52.4183 56 48V8C56 3.58172 52.4183 0 48 0Z",
    fill: "url(#paint0_linear_1_20475)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_20475",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 27,
    height: 27
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9974 15.1641H15.1641V41.9974H41.9974V15.1641Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_20475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5807 41.9974C35.9887 41.9974 41.9974 35.9887 41.9974 28.5808C41.9974 21.1729 35.9887 15.1641 28.5807 15.1641C21.1728 15.1641 15.1641 21.1729 15.1641 28.5808C15.1641 35.9887 21.1728 41.9974 28.5807 41.9974ZM27.6224 20.9141C27.6224 20.387 28.0536 19.9558 28.5807 19.9558C29.1078 19.9558 29.5391 20.387 29.5391 20.9141V28.1208L33.9714 31.6666C34.3835 31.9973 34.4505 32.601 34.1199 33.0131C33.933 33.2479 33.6551 33.3724 33.3724 33.3724C33.1615 33.3724 32.9507 33.3053 32.7735 33.1616L27.9818 29.3283C27.7566 29.1462 27.6224 28.8731 27.6224 28.5808V20.9141Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_20475",
    x1: 12.6808,
    y1: 43.3231,
    x2: 45.7139,
    y2: 10.2899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F42334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FC6058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7866"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_20475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerTwo);
export default __webpack_public_path__ + "static/media/timer-two.d3318d5cac79b89ed2c563d630ceb45c.svg";
export { ForwardRef as ReactComponent };